import { Modal } from './Modal.jsx';
import { Icon } from './Icon.jsx';
import { useT } from '../i18n/index.js';

export function ConfirmModal({ open, title, message, confirmLabel, tone = 'danger', onConfirm, onClose }) {
  const t = useT();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button className="btn sm" onClick={onClose}>{t('modal.cancel')}</button>
          <button
            className={`btn sm ${tone === 'danger' ? 'danger' : 'primary'}`}
            onClick={() => {
              onConfirm?.();
              onClose?.();
            }}
          >
            <Icon name={tone === 'danger' ? 'warning' : 'check'} size={14} />
            {confirmLabel || t('modal.confirm')}
          </button>
        </>
      }
    >
      <div className="row" style={{ alignItems: 'flex-start', gap: 12 }}>
        <div style={{ color: tone === 'danger' ? 'var(--danger)' : 'var(--accent)' }}>
          <Icon name={tone === 'danger' ? 'warning' : 'hint'} size={22} />
        </div>
        <div>{message}</div>
      </div>
    </Modal>
  );
}
